import { post } from "../utils/backend";
import { Resume, ResumeFilter } from "../models/Resume";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/ResumeMock";

// 获取简历列表
const getResumes = async (filter?: ResumeFilter): Promise<Resume[]> => {
    if (mock) {
        return getMockData("getResumes");
    }
    const resultOrErrorCode = await post<ResumeFilter | undefined, Resume[]>("/management/resume/getResumes", filter);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

// 根据条件查询简历
const queryByConditions = async (filter: ResumeFilter): Promise<Resume[]> => {
    if (mock) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(getMockData("getResumes"));
            }, 1000);
        });
    }
    const resultOrErrorCode = await post<ResumeFilter, Resume[]>("/management/resume/queryByConditions", filter);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

// 获取简历详情
const getResumeDetail = async (id: string): Promise<Resume> => {
    if (mock) {
        return getMockData("getResumeDetail");
    }
    const resultOrErrorCode = await post<{ id: string }, Resume>("/management/resume/getDetail", { id });
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return {} as Resume;
    }
    return resultOrErrorCode;
};

// 更新简历状态
const updateResumeStatus = async (id: string, isServing: boolean): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<{ id: string; isServing: boolean }, boolean>("/management/resume/updateStatus", { id, isServing });
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

// 删除简历
const deleteResume = async (id: string): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<{ id: string }, boolean>("/management/resume/delete", { id });
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const ResumeApi = {
    getResumes,
    queryByConditions,
    getResumeDetail,
    updateResumeStatus,
    deleteResume
}; 